<div class="settings-modal mat-body-2">
  <!-- Left Sidebar -->
  <div class="settings-modal-sidebar">
    <div class="profile-info">
      <h2>{{ companyName }}</h2>
      <p class="mat-caption user-name">{{ email }}</p>
    </div>
    <nav class="menu-options">
      <ul>
        <li [class.active]="selectedMenu === 'My Account'" (click)="selectMenu('My Account')">
          <mat-icon inline>person</mat-icon>
          My Account
        </li>
        <li [class.active]="selectedMenu === 'Security'" (click)="selectMenu('Security')">
          <mat-icon>work</mat-icon>
          Security
        </li>
        <li [class.active]="selectedMenu === 'Bank Account'" (click)="selectMenu('Bank Account')">
          <mat-icon>account_balance</mat-icon>
          Bank Account
        </li>
        <li [class.active]="selectedMenu === 'Important Links'" (click)="selectMenu('Important Links')">
          <mat-icon>link</mat-icon>
          Important Links
        </li>
        <li [class.active]="selectedMenu === 'Agreements'" (click)="selectMenu('Agreements')">
          <mat-icon>description</mat-icon>
          Agreements
        </li>
        <!-- <li [class.active]="selectedMenu === 'Users'" (click)="selectMenu('Users')">
        <mat-icon>group_add</mat-icon>
        Users
      </li> -->
      </ul>
    </nav>
  </div>

  <!-- Right Content Area -->
  <div class="main-content">
    <div class="header-bar">
      <h2>{{ selectedMenu }}</h2>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="content-area">
      @if (userData) {
      @switch (selectedMenu) {
      @case ('My Account') {
      <app-user-account-settings [userData]="userData"></app-user-account-settings>
      }
      @case ('Security') {
      <app-user-security-settings [userData]="userData"></app-user-security-settings>
      }
      @case ('Bank Account') {
      <app-user-bank-account></app-user-bank-account>
      }
      @case ('Important Links') {
      <app-user-links></app-user-links>
      }
      @case ('Agreements') {
      <app-user-agreements></app-user-agreements>
      }
      <!-- Removed in favor of people page -->
      <!--<app-user-invites
        *ngSwitchCase="'Users'"
        [userData]="userData"
        [members]="invitedMembers"
        [isLoading]="loading.members"
        (refresh)="loadInvitedMembers()">
      </app-user-invites>-->
      <!-- Fallback Content -->
      @default {
      <div>
        <p>Select an option from the sidebar.</p>
      </div>
      }
      }
      }
    </div>
  </div>
</div>